module.exports = __webpack_public_path__ + "static/insurance-51725ff5ce950eb300a87f3580d77140.png";